import React from 'react';

import JRDPDataLayer from '@travel/traveler-core/components/JRDPDataLayer';
import { ReactPortal } from '@travel/traveler-core/components/ReactPortal';

export type Props = { [key: string]: string | number | undefined } & {
  page: string;
  updateData?: string /* pass the changed data if params need to be updated on data change */;
};

const DataLayer = (props: Props) => {
  return (
    <ReactPortal>
      <JRDPDataLayer {...props} />
    </ReactPortal>
  );
};

export default DataLayer;
